import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { SettingsPermissions } from "@redotech/redo-model/permissions";

export function inAiKnowledgeView(url: string) {
  return url.includes("/ai/knowledge");
}

export function inAiContextLibraryView(url: string) {
  return url.includes("/ai/ai-context-library");
}

export const aiSettingsRoutes: PermissionedRouteObject = {
  handle: {
    breadcrumb: "AI",
    breadcrumbNavigate: false,
    permission: SettingsPermissions.SET_AI_SETTINGS,
  },
  path: "ai",
  children: [
    {
      path: "general",
      handle: { breadcrumb: "General" },
      lazy: async () => {
        const { GeneralSettingsPage } = await import("./general");
        return { Component: GeneralSettingsPage };
      },
    },
    {
      path: "skills",
      handle: { breadcrumb: "Skills" },
      lazy: async () => {
        const { SkillsSettingsPage } = await import("./skills");
        return { Component: SkillsSettingsPage };
      },
    },
    {
      path: "knowledge",
      handle: { breadcrumb: "Knowledge" },
      lazy: async () => {
        const { ConciergeKnowledgePage } = await import("./knowledge/page");
        return { Component: ConciergeKnowledgePage };
      },
    },
    {
      path: "ai-context-library",
      handle: { breadcrumb: "Context Library" },
      lazy: async () => {
        const { AiContextLibraryPage } = await import(
          "./ai-context-library/page"
        );
        return { Component: AiContextLibraryPage };
      },
    },
  ],
};
